import api from "./axios";

export const getNotificationsApi = async ({ page = 1, limit = 20 }: { page?: number; limit?: number } = {}) => {
  const response = await api.get("/api/notifications", { params: { page, limit } });
  return response.data;
};

export const getUnreadCountApi = async () => {
  const response = await api.get("/api/notifications/unread-count");
  return response.data;
};

export const markNotificationReadApi = async (notificationId: string) => {
  const response = await api.patch(`/api/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsReadApi = async () => {
  const response = await api.patch("/api/notifications/read-all");
  return response.data;
};

export const getNotificationPreferencesApi = async () => {
  const response = await api.get("/api/notifications/preferences");
  return response.data;
};

export const updateNotificationPreferencesApi = async (payload: Record<string, unknown>) => {
  const response = await api.put("/api/notifications/preferences", payload);
  return response.data;
};

export const pauseNotificationsApi = async () => {
  const response = await api.post("/api/notifications/preferences/pause");
  return response.data;
};

export const resumeNotificationsApi = async () => {
  const response = await api.delete("/api/notifications/preferences/pause");
  return response.data;
};
